module.exports = __webpack_public_path__ + "img/21_81.5b0e84c5.png";